import type { OptionType } from '@/types'

import { labelWithTooltip } from '../../RequiredLabel/labelWithTooltip'
import {
  ConfigBooleanSelectField,
  type ConfigFieldContext,
  ConfigSelectField,
} from '../ConfigFields/ConfigFields'
import cn from '../ConfigModal.module.scss'
import { CONFIG_TOOLTIPS } from '../lib/configModalTexts'

type ConfigBrandFieldsProps = {
  context: ConfigFieldContext
  brandNameOptions: OptionType[]
  brandOptions: OptionType[]
  brandsLoading: boolean
}

function ConfigBrandFields({
  context,
  brandNameOptions,
  brandOptions,
  brandsLoading,
}: ConfigBrandFieldsProps) {
  return (
    <div className={cn.grid}>
      <ConfigSelectField
        context={context}
        name="allowedBrands"
        title={labelWithTooltip(
          'Разрешённые бренды',
          CONFIG_TOOLTIPS.allowedBrands
        )}
        placeholder="Выберите бренды"
        options={brandNameOptions}
        multiple
        allowClear
      />
      <ConfigSelectField
        context={context}
        name="ignoredBrands"
        title={labelWithTooltip(
          'Исключённые бренды',
          CONFIG_TOOLTIPS.ignoredBrands
        )}
        placeholder="Выберите бренды"
        options={brandNameOptions}
        multiple
        allowClear
      />
      <ConfigSelectField
        context={context}
        name="fallbackBrandId"
        title={labelWithTooltip(
          'Бренд по умолчанию',
          CONFIG_TOOLTIPS.fallbackBrand
        )}
        placeholder="Не выбран"
        options={brandOptions}
        loading={brandsLoading}
        allowClear
      />
      <ConfigBooleanSelectField
        context={context}
        name="detectBrandInDescription"
        title="Искать бренд в наименовании товара"
        trueLabel="Да"
        falseLabel="Нет"
      />
    </div>
  )
}

export default ConfigBrandFields
